import { applyDemoProgressOverrides } from './demoProgress'
import {
    LeasingSeasonDetail,
    SeasonProgressApi,
    SeasonProgressMetrics,
} from '../types/leasingSeason.types'

function mapProgress(apiProgress: SeasonProgressApi): SeasonProgressMetrics {
    return {
        totalCapacity: apiProgress.total_capacity,
        signedNew: apiProgress.signed_new,
        signedRenewals: apiProgress.signed_renewals,
        leasedCount: apiProgress.leased_count,
        percentLeased: apiProgress.percent_leased,
        daysTotal: apiProgress.days_total,
        daysElapsed: apiProgress.days_elapsed,
        daysRemaining: apiProgress.days_remaining,
        expectedPercent: apiProgress.expected_percent,
        paceDelta: apiProgress.pace_delta,
        bedsToGoal: apiProgress.beds_to_goal,
        onPace: apiProgress.on_pace,
        behindBig: apiProgress.behind_big,
        isStub: apiProgress.is_stub,
    }
}

export function displayProgressFromApi(
    apiProgress: SeasonProgressApi | undefined,
): SeasonProgressMetrics | null {
    if (!apiProgress) return null
    return applyDemoProgressOverrides(mapProgress(apiProgress))
}

export function displayProgressFromDetail(
    detail: LeasingSeasonDetail | undefined,
): SeasonProgressMetrics | null {
    return displayProgressFromApi(detail?.progress)
}

export function percentLeasedFromDetail(
    detail: LeasingSeasonDetail | undefined,
): number | null {
    const metrics = displayProgressFromDetail(detail)
    return metrics?.percentLeased ?? null
}
